import { ApiDateSchema, ContractSchema, CustomerSchema, ObjectIdSchema, PlanSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const GetContractsOverviewsResponseSchema = oz.object({
  countedTotalActiveContractsOverviews: oz.number().nonnegative(),
  countedTotalContractsOverviews: oz.number().nonnegative(),
  countedFilteredContractsOverviews: oz.number().nonnegative(),
  contracts: oz.array(
    ContractSchema.pick({
      id: true,
      createdAt: true,
      status: true,
      startDate: true,
      endDate: true,
      syncStatus: true,
      syncStatusUpdatedAt: true,
    }).extend({
      createdAt: ApiDateSchema,
      revenue: oz.number(),
      customer: CustomerSchema.pick({
        name: true,
        settings: true,
      }),
      plan: PlanSchema.pick({
        id: true,
        name: true,
        billingData: true,
      }).extend({
        id: ObjectIdSchema,
      }),
    }),
  ),
}).openapi('GetContractsOverviewsResponse');

export type GetContractsOverviewsResponse = oz.infer<typeof GetContractsOverviewsResponseSchema>;